/**
 * @generated SignedSource<<b620eec300dee49b5ab815b2b56d8c66>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DownloadIndividualStudentReportInput = {
  isSummary: boolean;
  skillLearningActivityEndDate?: any | null | undefined;
  skillLearningActivityStartDate?: any | null | undefined;
  userIds: ReadonlyArray<string>;
  withAcknowledgment: boolean;
};
export type IndividualStudentReportPdfQuery$variables = {
  input: DownloadIndividualStudentReportInput;
  skip: boolean;
};
export type IndividualStudentReportPdfQuery$data = {
  readonly generateIndividualStudentReportPDFs?: {
    readonly base64Data: string;
    readonly fileName: string;
  };
};
export type IndividualStudentReportPdfQuery = {
  response: IndividualStudentReportPdfQuery$data;
  variables: IndividualStudentReportPdfQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "downloadIndividualStudentReportInput",
            "variableName": "input"
          }
        ],
        "concreteType": "FileResult",
        "kind": "LinkedField",
        "name": "generateIndividualStudentReportPDFs",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "base64Data",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fileName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IndividualStudentReportPdfQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IndividualStudentReportPdfQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "84f13667fc1c1dd19838f3345e67920e",
    "id": null,
    "metadata": {},
    "name": "IndividualStudentReportPdfQuery",
    "operationKind": "query",
    "text": "query IndividualStudentReportPdfQuery(\n  $input: DownloadIndividualStudentReportInput!\n  $skip: Boolean!\n) {\n  generateIndividualStudentReportPDFs(downloadIndividualStudentReportInput: $input) @skip(if: $skip) {\n    base64Data\n    fileName\n  }\n}\n"
  }
};
})();

(node as any).hash = "940d45acecd9ada31a32d0342846e92b";

export default node;
